import { Environment } from './environment.model';

export const environment: Environment = {
	production: false,
	clientId: 'evainsights_frontend',
	clientSecret: 'clientSecret',
	// dataServiceUrl: 'http://localhost:8081/api/data/',
	dataServiceUrl: 'https://dev.evainsights.de/api/data/',
	// reportServiceUrl: 'http://localhost:8082/api/report/',
	reportServiceUrl: 'https://dev.evainsights.de/api/report/',
	// authServiceUrl: 'http://localhost:8083/api/auth/',
	authServiceUrl: 'https://dev.evainsights.de/api/auth/',
	fallbackTenantSubdomain: 'sdi',
	enableDeveloperTools: true,
};
